import { useCallback, useEffect, useState } from 'react';

const fiveSeconds = 1000 * 5;

/**
 * We want to know if some time has passed since a condition was met. The time
 * should reset each time the passed flag changes.
 */
export default function useHasTimePassed(condition: boolean, flag: any) {
  const [hasTimePassed, setTimePassed] = useState(false);

  useEffect(() => {
    setTimePassed(false);

    if (!condition) return;

    const t = window.setTimeout(() => {
      setTimePassed(true);
    }, fiveSeconds);

    return () => {
      window.clearTimeout(t);
    };
  }, [condition, flag]);

  const resetTimer = useCallback(() => {
    setTimePassed(false);
  }, []);

  return { hasTimePassed, resetTimer };
}
